/**
 * Created by fers on 23.05.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

export default class EmptyContent extends React.Component {

	static propTypes = {
		message: PropTypes.any
	}

    render() {
        return (
            <div className="CenteredContentHolder"><div className="CenteredContent">
				{this.props.message || <FormattedMessage defaultMessage="No related data" id="emptyContent.noData" />}
			</div></div>
        );
    }
}
